import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Card, CardContent, TextField, Button, Autocomplete } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const ACCOUNT_TYPE_CHOICES = ['Cash', 'Bank', 'Credit Card', 'Other'];
const CURRENCY_CHOICES = ['PKR', 'USD', 'AED', 'EUR', 'GBP'];

const MoneyAccountFilters = ({
  searchTerm,
  accountTypeFilter,
  currencyFilter,
  filterOptions,
  onSearchChange,
  onAccountTypeFilterChange,
  onCurrencyFilterChange,
  onClearFilters,
}) => {
  // Use dynamic filter options or fallback to constants
  const accountTypeOptions =
    filterOptions?.account_types?.map((type) => ({ value: type, label: type })) ||
    ACCOUNT_TYPE_CHOICES.map((type) => ({ value: type, label: type }));
  const currencyOptions =
    filterOptions?.currencies?.map((curr) => ({ value: curr, label: curr })) ||
    CURRENCY_CHOICES.map((curr) => ({ value: curr, label: curr }));

  return (
    <Grid item xs={12}>
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6} md={2.5}>
              <TextField
                fullWidth
                placeholder="Search accounts..."
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                size="small"
                InputProps={{
                  startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Autocomplete
                size="small"
                value={{ value: accountTypeFilter, label: accountTypeFilter }}
                onChange={(event, newValue) => onAccountTypeFilterChange(newValue?.value || 'All')}
                options={[{ value: 'All', label: 'All' }, ...accountTypeOptions]}
                getOptionLabel={(option) => option?.label || ''}
                isOptionEqualToValue={(option, value) => option?.value === value?.value}
                renderInput={(params) => <TextField {...params} label="Account Type" />}
                clearOnEscape
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Autocomplete
                size="small"
                value={{ value: currencyFilter, label: currencyFilter }}
                onChange={(event, newValue) => onCurrencyFilterChange(newValue?.value || 'All')}
                options={[{ value: 'All', label: 'All' }, ...currencyOptions]}
                getOptionLabel={(option) => option?.label || ''}
                isOptionEqualToValue={(option, value) => option?.value === value?.value}
                renderInput={(params) => <TextField {...params} label="Currency" />}
                clearOnEscape
              />
            </Grid>
            <Grid item xs={12} sm={6} md={1}>
              <Button variant="outlined" onClick={onClearFilters} size="small" sx={{ height: '40px' }}>
                Clear Filters
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

MoneyAccountFilters.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  accountTypeFilter: PropTypes.string.isRequired,
  currencyFilter: PropTypes.string.isRequired,
  filterOptions: PropTypes.shape({
    account_types: PropTypes.arrayOf(PropTypes.string),
    currencies: PropTypes.arrayOf(PropTypes.string),
  }),
  onSearchChange: PropTypes.func.isRequired,
  onAccountTypeFilterChange: PropTypes.func.isRequired,
  onCurrencyFilterChange: PropTypes.func.isRequired,
  onClearFilters: PropTypes.func.isRequired,
};

MoneyAccountFilters.defaultProps = {
  filterOptions: {},
};

export default MoneyAccountFilters;
